import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import { FC, createElement } from 'react';
import { useSystemTheme } from '../../hooks/useSystemTheme';

const navigation = [
  { name: 'Accueil', path: '/' },
  { name: 'Mes compétences', path: '/about' },
  { name: 'Projets', path: '/projects' },
  { name: 'Contact', path: '/contact' },
];

export const Header: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDark } = useSystemTheme();
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  const MenuIcon = isOpen ? FiX : FiMenu;

  return (
    <header className="fixed w-full bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-gray-700/50 shadow-lg z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="flex items-center"
            >
              <div className="relative group">
                <div className="flex items-end">
                  <span className="text-3xl font-black text-indigo-600 dark:text-indigo-400 tracking-tighter transform -rotate-6 transition-transform group-hover:rotate-0">O</span>
                  <span className="text-3xl font-black text-gray-800 dark:text-white tracking-tighter transform translate-x-[-2px] translate-y-[-2px] transition-transform group-hover:translate-y-0">B</span>
                </div>
                <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-indigo-600 dark:bg-indigo-400 transition-all duration-300 group-hover:w-full"></div>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${
                  location.pathname === item.path
                    ? 'text-indigo-600 dark:text-indigo-400'
                    : 'text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400'
                } transition-colors duration-200`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-full bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm border border-gray-200/50 dark:border-gray-600/50 hover:bg-white/80 dark:hover:bg-gray-700/80 transition-all duration-200"
              aria-label="Toggle menu"
            >
              {createElement(MenuIcon as any, {
                size: 24,
                className: "text-gray-600 dark:text-gray-300"
              })}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <motion.div
          initial={false}
          animate={{ height: isOpen ? 'auto' : 0 }}
          transition={{ duration: 0.2 }}
          className="md:hidden overflow-hidden"
        >
          <div className="px-2 pt-2 pb-3 space-y-1 bg-white/70 dark:bg-gray-900/70 backdrop-blur-md border-t border-gray-200/50 dark:border-gray-700/50 m-2 rounded-xl">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${
                  location.pathname === item.path
                    ? 'bg-indigo-600/20 dark:bg-indigo-600/30 backdrop-blur-sm text-indigo-600 dark:text-indigo-400 border border-indigo-200/50 dark:border-indigo-500/50'
                    : 'text-gray-600 dark:text-gray-300 hover:bg-white/60 dark:hover:bg-gray-800/60 hover:backdrop-blur-sm hover:border hover:border-gray-200/50 dark:hover:border-gray-600/50'
                } block px-3 py-2 rounded-xl text-base font-medium transition-all duration-200`}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </motion.div>
      </nav>
    </header>
  );
}; 